<template>
  <v-app>
    <v-main>
      <v-container>
        <v-row class="my-5">
          <v-col cols="12">
            <v-img :src="require('./assets/header.jpg')" />
          </v-col>
        </v-row>

        <v-row class="my-3">
          <router-view />
        </v-row>

        <v-row class="my-5">
          <v-col cols="12">
            <v-img :src="require('./assets/logotypy_eu.jpg')" />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>